export const answersToFields = (questionList, answers, data) => {
  let initialAnswers = {};
  let questionIdMapping = {};
  let spzContacts = {};
  let select7 = [];
  let select18 = [];
  let selection = {};

  if (Boolean(data.specialization)) {
    Object.keys(data["specialization"]).map((ele) => {
      if (ele.startsWith("specializationContact")) {
        Object.keys(data["specialization"][ele]).map((innerElement) => {
          spzContacts[ele + "_" + innerElement] =
            data["specialization"][ele][innerElement];
        });
      }
    });
  }

  for (let k = 0; k < questionList.length; k++) {
    questionIdMapping[questionList[k].questionNumber] = {
      questionId: questionList[k].id,
      question: questionList[k].question,
    };
  }

  for (let i = 0; i < answers.length; i++) {
    Object.keys(answers[i]).map((ele) => {
      if (
        ele != "question" &&
        ele != "questionId" &&
        ele != "answerDetails" &&
        ele != "questionNumber"
      ) {
        initialAnswers["qt_" + answers[i]["questionNumber"] + "_" + ele] =
          answers[i][ele];
      }

      if (ele === "answerDetails") {
        if (answers[i]["answerDetails"].length == 1) {
          Object.keys(answers[i]["answerDetails"][0]).map((element) => {
            if (element != "answerDetailId" && element != "questionNumber") {
              initialAnswers[
                "qt-" + answers[i]["questionNumber"] + "-" + element
              ] = answers[i]["answerDetails"][0][element];
            }
          });
        } else {
          for (let j = 0; j < answers[i]["answerDetails"].length; j++) {
            //let temp;
            //temp = answers[i]["answerDetails"][j]["questionDetailNumber"].split(".")
            Object.keys(answers[i]["answerDetails"][j]).map((element) => {
              if (element != "answerDetailId" && element != "questionNumber") {
                initialAnswers[
                  "qt-" + answers[i]["questionNumber"] + "-" + element + "-" + j
                ] = answers[i]["answerDetails"][j][element];
              }
            });
          }
        }
      }
    });
  }

  select7 = initialAnswers["qt_7_textAreaAnswer"]
    ? initialAnswers["qt_7_textAreaAnswer"].split(";")
    : [];
  select18 = initialAnswers["qt_18_textAreaAnswer"]
    ? initialAnswers["qt_18_textAreaAnswer"].split(";")
    : [];
  initialAnswers["qt_7_textAreaAnswer"] = "";
  initialAnswers["qt_18_textAreaAnswer"] = "";

  for (let l = 0; l < select7.length; l++) {
    if (select7[l] != " " && select7[l] != "") {
      selection["st_7_" + select7[l]] = true;
    }
  }
  for (let m = 0; m < select18.length; m++) {
    if (select18[m] != " " && select18[m] != "") {
      selection["st_18_" + select18[m]] = true;
    }
  }

  return { questionIdMapping, initialAnswers, spzContacts, selection };
};

export const createPostBody = (
  values,
  questionIdMapping = {},
  accountId,
  initialFields,
) => {
  let answersObj = {};
  let mqe;
  let fqe;
  let answersObjKey;
  let spzContact0 = {};
  let spzContact1 = {};
  let select7 = "";
  let select18 = "";
  let ans10 = {
    questionNumber: "10",
    answerDetails: [{}, {}, {}],
    questionId: questionIdMapping[10].questionId,
    question: questionIdMapping[10].question,
  };
  let ans34 = {
    questionNumber: "34",
    answerDetails: [{}, {}, {}, {}],
    questionId: questionIdMapping[34].questionId,
    question: questionIdMapping[34].question,
  };
  let attachmentDetail = {};

  Object.keys(values).map((ele) => {
    let temp;
    if (Boolean(values[ele]) && ele.startsWith("st_18_")) {
      temp = ele.split("_");
      select18 = select18 + temp[2] + ";";
    }
  });
  if (select18 == "" || select18 == " ") {
    return { select18Error: true };
  }
  Object.keys(values).map((ele) => {
    let temp;
    if (Boolean(values[ele]) && ele.startsWith("st_7_")) {
      temp = ele.split("_");
      select7 = select7 + temp[2] + ";";
    }
  });

  values["qt_18_textAreaAnswer"] = select18;
  values["qt_7_textAreaAnswer"] = select7;

  //let textAreaRequired = ["12","13","14","17","32"];
  let txtAreaType1 = (questionNumber, labels) => {
    let textAreaAnswer = "";
    let answerNum = 0;
    for (let i = 0; i < labels.length; i++) {
      answerNum = i + 1;
      textAreaAnswer =
        textAreaAnswer +
        labels[i] +
        ":" +
        values["qt_" + questionNumber + "_answer" + answerNum] +
        "\n";
    }
    values["qt_" + questionNumber + "_textAreaAnswer"] = textAreaAnswer;
  };

  let txtAreaType2 = (questionNumber, labels) => {
    let textAreaAnswer = "";
    let answerNum = 0;
    let answerNum2 = 0;
    let firstLabel = 0;
    let secondLabel = 1;
    for (let i = 0; i <= labels.length / 3; i++) {
      answerNum = i + 1;
      answerNum2 = answerNum + 3;
      textAreaAnswer =
        textAreaAnswer +
        labels[firstLabel] +
        "::" +
        values["qt_" + questionNumber + "_answer" + answerNum2] +
        "," +
        labels[secondLabel] +
        "::" +
        values["qt_" + questionNumber + "_answer" + answerNum] +
        "\n";
      firstLabel = firstLabel + 2;
      secondLabel = secondLabel + 2;
    }
    values["qt_" + questionNumber + "_textAreaAnswer"] = textAreaAnswer;
  };

  let txtAreaType3 = (questionNumber, labels) => {
    let textAreaAnswer = "";
    let answerNum = 0;
    for (let i = 0; i < labels.length; i++) {
      answerNum = i + 1;
      textAreaAnswer =
        textAreaAnswer +
        answerNum +
        ".\t" +
        labels[i] +
        ":" +
        values["qt_" + questionNumber + "_answer" + answerNum] +
        "%\n";
    }
    values["qt_" + questionNumber + "_textAreaAnswer"] = textAreaAnswer;
  };

  let textAreaRequired = {
    32: { type: 1, labels: ["Sales", "Technical", "Marketing/Other", "Total"] },
    13: {
      type: 3,
      labels: [
        "Small Business (<$50m in sales)",
        "Medium Business ($50m - $500m)",
        "Large Business (>$500m)",
        "Federal Government",
        "State/Provincial Government",
        "Local/Municipal Government",
        "Education",
        "Non-profit Organizations",
      ],
    },
    14: {
      type: 1,
      labels: [
        "Vendor",
        "Product Line",
        "%Sales",
        "Vendor",
        "Product Line",
        "%Sales",
        "Vendor",
        "Product Line",
        "%Sales",
      ],
    },
    17: {
      type: 2,
      labels: ["First", "Revenue", "Second", "Revenue", "Third", "Revenue"],
    },
    12: {
      type: 3,
      labels: [
        "Hardware Systems/Peripherals",
        "Vertical Software",
        "Horizontal Software",
        "Integration",
        "Consulting",
        "Hosting/Service",
        "Maintenance",
        "Other",
      ],
    },
  };

  Object.keys(textAreaRequired).map((questionNumber) => {
    if (textAreaRequired[questionNumber]["type"] == 1) {
      txtAreaType1(questionNumber, textAreaRequired[questionNumber]["labels"]);
    } else if (textAreaRequired[questionNumber]["type"] == 2) {
      txtAreaType2(questionNumber, textAreaRequired[questionNumber]["labels"]);
    } else if (textAreaRequired[questionNumber]["type"] == 3) {
      txtAreaType3(questionNumber, textAreaRequired[questionNumber]["labels"]);
    }
  });

  Object.keys(values).map((ele) => {
    //mqe->main question element
    mqe = ele.split("_");
    if (Boolean(values[ele])) {
      if (
        ele.startsWith("specializationContact0_") &&
        ele != "specializationContact0_id"
      ) {
        if (mqe[1] === "email" && values[ele] === initialFields[ele]) {
          spzContact0["id"] = values["specializationContact0_id"];
        }
        spzContact0[mqe[1]] = values[ele];
      } else if (
        ele.startsWith("specializationContact1_") &&
        ele != "specializationContact1_id"
      ) {
        if (mqe[1] === "email" && values[ele] === initialFields[ele]) {
          spzContact1["id"] = values["specializationContact1_id"];
        }
        spzContact1[mqe[1]] = values[ele];
      } else if (ele.startsWith("qt_")) {
        answersObjKey = mqe[0] + "_" + mqe[1];
        if (answersObj[answersObjKey]) {
          answersObj[answersObjKey][mqe[2]] = values[ele];
        } else {
          let obj = {};
          //obj["questionType"] = mqe[0];
          obj["questionNumber"] = mqe[1];
          obj["questionId"] = questionIdMapping[mqe[1]].questionId;
          obj["question"] = questionIdMapping[mqe[1]].question;
          obj[mqe[2]] = values[ele];
          answersObj[answersObjKey] = obj;
        }
      }
    }
  });

  Object.keys(values).map((ele) => {
    //fqe->followup question element
    fqe = ele.split("-");
    if (Boolean(values[ele])) {
      if (ele.startsWith("qt-10")) {
        if (fqe[3] == "0") {
          ans10["answerDetails"][0][fqe[2]] = values[ele];
        } else if (fqe[3] == "1") {
          ans10["answerDetails"][1][fqe[2]] = values[ele];
        } else if (fqe[3] == "2") {
          ans10["answerDetails"][2][fqe[2]] = values[ele];
        }
      } else if (ele.startsWith("qt-34")) {
        if (fqe[3] == "0") {
          ans34["answerDetails"][0][fqe[2]] = values[ele];
        } else if (fqe[3] == "1") {
          ans34["answerDetails"][1][fqe[2]] = values[ele];
        } else if (fqe[3] == "2") {
          ans34["answerDetails"][2][fqe[2]] = values[ele];
        } else if (fqe[3] == "3") {
          ans34["answerDetails"][3][fqe[2]] = values[ele];
        }
      } else if (ele.startsWith("qt-")) {
        answersObjKey = fqe[0] + "_" + fqe[1];
        if (fqe[3]) {
          // if (answersObj[answersObjKey]) {
          //     if (answersObj[answersObjKey]["answerDetails"]) {
          //         let obj = {};
          //         //obj["questionDetailNumber"] = fqe[1] + "." + fqe[3];
          //         obj[fqe[2]] = values[ele];
          //         answersObj[answersObjKey]["answerDetails"].push(obj);
          //     }
          //     else {
          //         answersObj[answersObjKey]["answerDetails"] = [];
          //         let obj = {};
          //         //obj["questionDetailNumber"] = fqe[1] + "." + fqe[3];
          //         obj[fqe[2]] = values[ele];
          //         answersObj[answersObjKey]["answerDetails"].push(obj);
          //     }
          // }
          // else {
          //     answersObj[answersObjKey] = { "answerDetails": [] };
          //     let obj = {};
          //     //obj["questionDetailNumber"] = fqe[1] + "." + fqe[3];
          //     obj[fqe[2]] = values[ele];
          //     answersObj[answersObjKey]["answerDetails"].push(obj);
          // }
        } else {
          if (answersObj[answersObjKey]) {
            if (answersObj[answersObjKey]["answerDetails"])
              answersObj[answersObjKey]["answerDetails"][0][fqe[2]] =
                values[ele];
            else {
              answersObj[answersObjKey]["answerDetails"] = [];
              let obj = {};
              //obj["questionDetailNumber"] = fqe[1] + ".1"
              obj[fqe[2]] = values[ele];
              answersObj[answersObjKey]["answerDetails"].push(obj);
            }
          }
        }
      }
    }
  });

  let answers = [];
  Object.keys(answersObj).map((ele) => {
    answers.push(answersObj[ele]);
  });
  answers.push(ans10);
  answers.push(ans34);
  attachmentDetail = {
    attName: values["attachmantName"],
    contentType: values["contentType"],
    attBody: values["attachmantBody"],
  };

  // Check if "spzContact1" is empty, if yes then set it to null rather than sending an empty object
  spzContact1 =
    Object.keys(spzContact1).length > 0 &&
    Object.values(spzContact1).some((val) => val !== null && val !== undefined)
      ? spzContact1
      : null;

  return {
    specialization: "Government",
    accountId: accountId,
    specializationContact0: spzContact0,
    specializationContact1: spzContact1,
    splznQuestReq: { answers: answers },
    attachmentDetail: attachmentDetail,
  };
};
